import { takeLatest, call, put } from 'redux-saga/effects';
import contactUsActions from './actions';
import errorActions from '../error/actions';
import dxApi from 'services/dxApi';

const {
  Types: { LOAD_DROPDOWN_DATA_REQUEST, SUBMIT_CONTACT_REQUEST },
  Creators: {
    loadDropdownDataSuccess,
    loadDropdownDataFailure,
    submitContactFailure,
    submitContactSuccess,
  },
} = contactUsActions;

const {
  Creators: { setError },
} = errorActions;

function* loadDropdownData() {
  try {
    const { data } = yield call(dxApi.get, `/api/hsforms/get-contactus-formdata`);
    if (!data.success) {
      yield put(loadDropdownDataFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(loadDropdownDataSuccess(data.data));
    }
  } catch (error) {
    yield put(loadDropdownDataFailure(error));
    yield put(setError('Load primary card error.'));
  }
}

function* submitContact({ payload }) {
  try {
    const { data } = yield call(dxApi.post, `/api/hsforms/hs-contactus-portal`, payload);
    if (!data.success) {
      yield put(submitContactFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(submitContactSuccess(data));
    }
  } catch (error) {
    yield put(submitContactFailure(error));
    yield put(setError('Submit contact-us error.'));
  }
}

export function* contactUsSaga() {
  yield takeLatest(LOAD_DROPDOWN_DATA_REQUEST, loadDropdownData);
  yield takeLatest(SUBMIT_CONTACT_REQUEST, submitContact);
}
